import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/soluciones/tecnologia-aprendizaje/athena-lms")({
  head: () => ({
    meta: [
      { title: "Athena LMS + Zeus | Tecnología de Aprendizaje | Mine Class" },
      {
        name: "description",
        content:
          "Athena, LMS minero mobile-first con FaceID y anti-trampa IA, integrado con Zeus para la gestión integral del entrenamiento corporativo.",
      },
      { property: "og:title", content: "Athena LMS + Zeus | Mine Class" },
      { property: "og:description", content: "LMS minero mobile-first con FaceID y anti-trampa IA, integrado con Zeus para la gestión integral del entrenamiento corporativo." },
      { property: "og:url", content: "https://mine-class.com/soluciones/tecnologia-aprendizaje/athena-lms" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mine-class.com/soluciones/tecnologia-aprendizaje/athena-lms" }],
  }),
  component: AthenaZeusContent,
});

function AthenaZeusContent() {
  return (
    <article className="space-y-8 text-[var(--color-on-surface-variant)] text-base md:text-lg leading-relaxed">
      <div>
        <span className="text-[10px] uppercase tracking-widest font-bold text-[var(--color-brand-coral)]">
          LMS Minero + Gestión de entrenamiento
        </span>
        <h2 className="text-2xl md:text-3xl font-bold text-[var(--color-brand-purple)] mt-1">
          Athena LMS + Zeus
        </h2>
      </div>

      {/* ATHENA */}
      <section className="space-y-4">
        <h3 className="text-xl font-bold text-[var(--color-brand-purple)]">Athena — LMS Minero</h3>
        <p>
          Plataforma de aprendizaje diseñada específicamente para la industria minera. Athena centra su
          experiencia en la simplicidad: una interfaz limpia, intuitiva y mobile-first que reduce la
          fricción y maximiza el aprendizaje, pensada para trabajadores y trabajadoras en cualquier
          contexto operativo.
        </p>
        <p>
          Es un entorno de formación seguro y confiable. Se integra de forma nativa con{" "}
          <strong>FaceID</strong> para garantizar la identidad del participante durante todo el proceso, e
          incorpora mecanismos <strong>anti-trampa impulsados por IA</strong> que aseguran la validez de
          cada evaluación. Al aprobar, genera certificados digitales en tiempo real.
        </p>
        <p>
          Athena es flexible y escalable por diseño: integrable vía API con cualquier sistema, totalmente
          personalizable en look and feel (whitelabel), y preparada para soportar contenidos y
          evaluaciones en múltiples formatos.
        </p>

        <ul className="grid md:grid-cols-2 gap-2.5 text-base pt-2">
          {[
            "Integración nativa con FaceID",
            "Mecanismos anti-trampa con IA",
            "Certificados digitales en tiempo real",
            "Reportería a la medida",
            "Soporte al alumno 24/7",
            "Integrable por API",
            "Whitelabel customizable",
            "Mobile-first",
            "Escalable",
            "Multiformato",
          ].map((f) => (
            <li key={f} className="flex items-start gap-2">
              <span className="material-symbols-outlined text-[var(--color-brand-coral)] text-base mt-1">
                check_circle
              </span>
              {f}
            </li>
          ))}
        </ul>
      </section>

      {/* ZEUS */}
      <section className="space-y-4 pt-6 border-t border-[var(--color-outline-variant)]">
        <h3 className="text-xl font-bold text-[var(--color-brand-purple)]">
          Zeus — Gestión integral de entrenamiento
        </h3>
        <p>
          Plataforma de gestión integral de los procesos de entrenamiento corporativo. Zeus centraliza y
          automatiza la administración de la formación, disminuyendo la carga operativa de los equipos
          para que puedan enfocarse en lo que realmente importa.
        </p>
        <p>
          Diseñado para trabajar en conjunto con Athena, se integra de forma nativa con el LMS y permite
          separar las reglas de negocio y los aspectos comerciales del entorno de estudio: los estudiantes
          acceden a una experiencia de aprendizaje limpia y sin distracciones, mientras la organización
          opera en un entorno de gestión ordenado y eficiente.
        </p>
        <p>
          Incorpora una <strong>IA asistente</strong> capaz de ejecutar las tareas que le solicites y
          entrega reportería en tiempo real que da visibilidad completa sobre el estado de cada proceso.
        </p>

        <div className="flex flex-wrap gap-2 pt-2">
          {["IA asistente", "Integra Athena", "Reportería real-time", "Automatización"].map((f) => (
            <span
              key={f}
              className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-[var(--color-brand-coral)]/10 text-[var(--color-brand-coral)] text-[11px] font-semibold"
            >
              <span className="material-symbols-outlined text-[13px]">check</span>
              {f}
            </span>
          ))}
        </div>
      </section>

      <div className="pt-4">
        <Link
          to="/contacto"
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-[var(--color-brand-coral)] text-white text-xs font-bold uppercase tracking-widest rounded-full hover:bg-[var(--color-brand-purple)] transition-colors"
        >
          Contactar un Experto
          <span className="material-symbols-outlined text-base">arrow_forward</span>
        </Link>
      </div>
    </article>
  );
}
